import { RULES_ROOT_STORE_PATH } from './constants'
import { addNamespace } from '@/store/helpers'

// To be used only inside vuex modules
export const _actions = {
  INIT_RULES_MODULE: 'initRulesModule',
  LOAD_PROJECTS: 'loadProjects',
  LOAD_PACKAGES: 'loadPackages',
  RELOAD_PROJECTS: 'reloadProjects',
  RELOAD_PACKAGES: 'reloadPackages',
  LOAD_CATALOG: 'loadCatalog',
  RELOAD_CATALOG: 'reloadCatalog',
  SET_ACTIVE_PROJECT: 'setActiveProject',
  REFRESH_ACTIVE_PROJECT: 'refreshActiveProject',
  GET_UNCOMMITTED_COMPONENTS: 'getUncommittedComponents'
}

// To be used publicly outside vuex modules
export const ACTIONS = addNamespace(
  RULES_ROOT_STORE_PATH,
  _actions
)
